import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { DownloadNlFormsQueryVariables } from '@/gql/graphql';

export const downloadNLForms = async ({
  natureOfComplaint,
  queryKey,
  query,
  startDate,
  endDate,
}: DownloadNlFormsQueryVariables): Promise<string> => {
  const response = await queryExecute({
    variables: {
      natureOfComplaint,
      queryKey,
      query,
      startDate,
      endDate,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query DownloadNLForms($natureOfComplaint: String, $queryKey: String, $query: String, $startDate: String, $endDate: String) {
        downloadNLForms(natureOfComplaint: $natureOfComplaint, queryKey: $queryKey, query: $query, startDate: $startDate, endDate: $endDate)
      }
    `),
  });

  return response.data?.downloadNLForms ?? '';
};
